import { OnlineUser } from 'kiolyn-api';
import newId from './NewId';

export default function newUser(): OnlineUser {
  let user: OnlineUser = {
    id: newId(),
    name: '',
    type: 'online-user',
    customer_name: '',
    customer_email: '',
    password: ''
  };
  return user;
}
